import { render } from "./SmIconDeleteComponent.vue?vue&type=template&id=14802d83"
import script from "./SmIconDeleteComponent.vue?vue&type=script&lang=js"
export * from "./SmIconDeleteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmIconDeleteComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14802d83"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14802d83', __exports__)) {
    api.reload('14802d83', __exports__)
  }
  
  module.hot.accept("./SmIconDeleteComponent.vue?vue&type=template&id=14802d83", () => {
    api.rerender('14802d83', render)
  })

}


export default __exports__